import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import { TaxDeclarationSavedDraftDataFragmentDoc } from "../../fragments/taxDeclarationSavedDraftData.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type EuerDeclarationSavedDraftInfoQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  year: Types.Scalars["Int"];
}>;

export type EuerDeclarationSavedDraftInfoQuery = {
  __typename?: "Query";
  euerDeclaration: {
    __typename?: "EuerDeclaration";
    savedDraftInfo?: {
      __typename?: "TaxDeclarationSavedDraftInfo";
      createdAt?: string | null;
      createdBy?: string | null;
      updatedAt?: string | null;
      pdf?: string | null;
      calculationSheet?: string | null;
      externalAssets?: Array<{
        __typename?: "TaxDeclarationExternalAsset";
        url: string;
        filetype: string;
        createdAt: string;
      }> | null;
    } | null;
  };
};

export const EuerDeclarationSavedDraftInfoDocument = gql`
  query euerDeclarationSavedDraftInfo($email: String!, $year: Int!) {
    euerDeclaration(email: $email, year: $year) {
      savedDraftInfo {
        ...TaxDeclarationSavedDraftData
      }
    }
  }
  ${TaxDeclarationSavedDraftDataFragmentDoc}
`;

/**
 * __useEuerDeclarationSavedDraftInfoQuery__
 *
 * To run a query within a React component, call `useEuerDeclarationSavedDraftInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEuerDeclarationSavedDraftInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEuerDeclarationSavedDraftInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useEuerDeclarationSavedDraftInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    EuerDeclarationSavedDraftInfoQuery,
    EuerDeclarationSavedDraftInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EuerDeclarationSavedDraftInfoQuery,
    EuerDeclarationSavedDraftInfoQueryVariables
  >(EuerDeclarationSavedDraftInfoDocument, options);
}
export function useEuerDeclarationSavedDraftInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EuerDeclarationSavedDraftInfoQuery,
    EuerDeclarationSavedDraftInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EuerDeclarationSavedDraftInfoQuery,
    EuerDeclarationSavedDraftInfoQueryVariables
  >(EuerDeclarationSavedDraftInfoDocument, options);
}
export type EuerDeclarationSavedDraftInfoQueryHookResult = ReturnType<
  typeof useEuerDeclarationSavedDraftInfoQuery
>;
export type EuerDeclarationSavedDraftInfoLazyQueryHookResult = ReturnType<
  typeof useEuerDeclarationSavedDraftInfoLazyQuery
>;
export type EuerDeclarationSavedDraftInfoQueryResult = Apollo.QueryResult<
  EuerDeclarationSavedDraftInfoQuery,
  EuerDeclarationSavedDraftInfoQueryVariables
>;
